import {
  AbsolutePositionAligner,
  IosArrowDown,
  Menu,
  MenuItem,
  useDocumentEvent,
} from '@sgcmpteltd/uikit-react';
import {
  DOCUMENT_EVENT_NAME_CLICK,
} from '@sgcmpteltd/uikit-react/hooks/use-document-event';
import {
  alignBottomXCenter,
} from '@sgcmpteltd/uikit-react/utils/position/fixed';
import cx from 'clsx';
import { useRef, useState } from 'react';

import { resultPerPageDropdownItemsConfig } from './configs';
import { ARROW_ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ResultPerPageDropdown: Component = ({
  value,
  isSearchPending,
  onChange,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const onDocMouseClickRef = useRef<Document['onclick'] | null>(null);
  const resultPerPageBtnElRef = useRef<HTMLButtonElement>(null);

  onDocMouseClickRef.current = ({ target }) => {
    if (
      (target instanceof Node
      && (resultPerPageBtnElRef.current?.isEqualNode(target)))
    ) {
      return;
    }
    setIsMenuOpen(false);
  };

  useDocumentEvent({
    eventName: DOCUMENT_EVENT_NAME_CLICK,
    eventHandlerRef: onDocMouseClickRef,
  });

  const handleBtnClick = () => {
    setIsMenuOpen(prev => !prev);
  };

  const handleMenuItemClick = (val?: number | string) => {
    if (typeof val === 'number' && onChange) {
      onChange(val);
    }

    setIsMenuOpen(false);
  };

  return (
    <div className={styles.containerRoot}>
      <AbsolutePositionAligner
        autoLocate={false}
        isActive={isMenuOpen}
        offset={{ top: 28 }}
        rectCalculator={alignBottomXCenter}
        targetElement={(
          <Menu className={cx(
            styles.menuRoot,
            styles.isBorder,
          )}>
            {resultPerPageDropdownItemsConfig.map(v => (
              <MenuItem
                key={v}
                className={styles.liDesktopMenuItem}
                isActive={value === v}
                value={v}
                onClick={handleMenuItemClick}>
                {v}
              </MenuItem>
            ))}
          </Menu>
        )}
        targetElementClassName={styles.containerMenu}>
        <button
          ref={resultPerPageBtnElRef}
          aria-label="Result Per Page"
          className={styles.button}
          disabled={isSearchPending}
          type="button"
          onClick={handleBtnClick}>
          {value}
        </button>
      </AbsolutePositionAligner>
      <IosArrowDown
        className={cx(
          styles.iconArrow,
          isMenuOpen && styles.isOpen,
        )}
        size={ARROW_ICON_SIZE} />
    </div>
  );
};
